import { object, ObjectSchema, string } from 'yup';

export const baseSchema = (): ObjectSchema<{ name: string; code: string }> => {
    return object().shape({
        name: string().required(),
        code: string().required(),
    });
};
